import * as KNReise from './knreise';
import multiSearch from '../redux/multiSearch';
import { olUtils } from 'react-openlayers';
var externalSourceThumbUrl = 'proxies/xThumbnailService.ashx?';
var themeSourceThumbUrl = 'WebServices/generic/Media.asmx/Download?uuid=';
var _instanceUrl = null;
var _recaptchaSiteKey = null;
export function instanceUrl() {
  return _instanceUrl;
}
export function recaptchaSiteKey() {
  return _recaptchaSiteKey;
}
export function getArticleThumb(article, size) {
  var props = article.properties;
  var url = undefined;

  if (props.image) {
    url = props.image;
  } else if (props.images && props.images[0]) {
    url = props.images[0];
  } else {
    url = props.thumbnail;
  }

  if (url && _instanceUrl) {
    var source = KNReise.getSource(article.id.split('_')[0]);

    if (source.value.api === 'norvegiana' || source.value.api === 'dimu' || source.value.api === 'wikipedia' || source.cache) {
      url = _instanceUrl + externalSourceThumbUrl + '&size=';

      switch (size) {
        case 'large':
          url += '1200';
          break;

        case 'medium':
          url += '800';
          break;

        case 'small':
        default:
          url += '400';
          break;
      }

      url += '&url=' + (props.images && props.images[0]);
    } else if (source.value.api === 'avdigitheme' || source.value.api === 'dimu' || source.value.api === 'avtheme') {
      url = _instanceUrl + themeSourceThumbUrl + props.thumbnail + '&thumbnail_size=';

      switch (size) {
        case 'large':
          url += 'large';
          break;

        case 'medium':
          url += 'medium';
          break;

        case 'small':
        default:
          url += 'small';
          break;
      }
    }
  }

  return url;
}
export function getArticles(articles, activeSources, sortFromPoint, projCode) {
  var renderArticles = Object.values(articles).filter(function (article) {
    return article.sources && article.sources.some(function (source) {
      return activeSources.indexOf(source) !== -1;
    });
  });

  if (sortFromPoint) {
    var pointWgs84 = olUtils.transformCoordinate(sortFromPoint, projCode, 'EPSG:4326');

    var calculateDistance = function calculateDistance(geom) {
      return olUtils.calculateDistance(olUtils.transformCoordinate(olUtils.getCenterFromGeom(geom), projCode, 'EPSG:4326'), pointWgs84);
    };

    var distance = {};
    renderArticles.sort(function (a, b) {
      if (!a.olFeature) return 1;
      if (!b.olFeature) return -1;
      var aDist = distance[a.id] = distance[a.id] || calculateDistance(a.olFeature.getGeometry());
      var bDist = distance[b.id] = distance[b.id] || calculateDistance(b.olFeature.getGeometry());
      return aDist - bDist;
    });
  }

  return renderArticles;
}
export function getThemeDataColumnsAsObject(source) {
  var colObj = {};
  source.config.theme_data.columns.forEach(function (col) {
    colObj[col.column_name] = col;
  });
  return colObj;
}
export function formatColumnValue(value, valueFormatter, dataType, locale) {
  dataType = getDataTypeName(dataType);
  var dateOpts = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  };
  var datetimeOpts = {
    hour: 'numeric',
    minute: 'numeric',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  };
  var timeOpts = {
    hour: 'numeric',
    minute: 'numeric'
  };

  switch (dataType) {
    case 'date':
    case 'datetime':
    case 'time':
      value = stringToDate(value);

      if (!value) {
        return;
      }

      if (dataType === 'date') {
        value = value.toLocaleString(locale, dateOpts);
      } else if (dataType === 'datetime') {
        value = value.toLocaleString(locale, datetimeOpts);
      } else {
        value = value.toLocaleString(locale, timeOpts);
      }

      break;

    case 'decimal':
    case 'single':
    case 'double':
      value = Number(value).toFixed(2);
      break;

    case 'integer':
      value = Number(value).toFixed(0);
      break;

    default:
      break;
  }

  if (!value || !valueFormatter) return value;
  return valueFormatter.replace(/##VALUE##/g, value);
}

function getDataTypeName(dataType) {
  switch (dataType) {
    case '154627bd-2b5e-4ecb-97ef-c4af7d3e01c6':
      return 'date';

    case '39a354c5-ea82-4bfd-b7db-2628984fcd6e':
      return 'time';

    case '2a76ddc3-2d32-4476-82ae-58ce06dd5652':
      return 'datetime';

    case '4d2ff201-1757-4133-aeda-ea5217c1d6f6':
      return 'boolean';

    case '61980343-edc4-4acc-be16-c313711b9fd4':
      return 'decimal';

    case 'bc3f2551-d3e0-4a27-831d-6c869ab920f5':
      return 'single';

    case '4b2a5e2d-c2ac-4822-b486-07e3989e0eed':
      return 'double';

    case '404c8d64-3727-476f-8631-3fbd03ca738b':
      return 'integer';

    case 'dee25205-d3a3-42a5-870f-8d673491b2cf':
      return 'text';

    case '521e4fed-87f5-4cfa-9911-94f98afcb708':
      return 'serial';

    case 'f37929f7-12b0-46f7-a681-026e6a554cba':
      return 'foreig_key';

    case '7989471b-8a83-4501-a9a8-0b9798cc9e53':
      return 'uuid';

    case '4b9a1fb5-c35f-472e-a4d7-176f4ceaa290':
      return 'list';

    case '3386dc9b-6143-4cba-8c38-d8b4a96d0bdc':
      return 'multiselect_list';

    case '41becc03-4c9a-4587-8291-2e50b20e9d5b':
      return 'editiable_list';

    case 'fcd7139f-06ac-4526-a7a9-48dfe3de3463':
      return 'geometry';

    case '2b7e661f-cf07-4fcd-8d44-0d664c819356':
      return 'picture';

    case '57afb4a6-384d-46fc-99b3-e1d55c5618fe':
      return 'document';

    case '8d1fb2ce-c9b8-4feb-8c58-001738ccc03b':
      return 'file';

    case '22f04234-0055-4e74-aa50-98f89cddc080':
      return 'rich_text';

    case '63fe55ef-0a0b-47c3-9027-d98ad885d1f1':
      return 'text_area';

    case '76c2a3d6-4e46-4d23-b444-256fc2c8bd5a':
      return 'media';

    case '92f9c7c3-90b3-41f9-bb4b-e37cc681db68':
      return 'url';

    case 'bc8e073b-12bd-42c3-b087-1ea3b5472e5f':
      return 'url[]';
  }
}

function stringToDate(date) {
  if (date && typeof date === 'string') {
    if (date.indexOf('/Date') === 0) {
      date = date.replace('/Date(', '');
      date = date.replace(')/', '');
      return new Date(parseInt(date, 10) || date);
    } else {
      return new Date(date);
    }
  } else {
    return undefined;
  }
}

export default {
  init: function init(instanceUrl, sources, recaptchaSiteKey) {
    _instanceUrl = instanceUrl;
    KNReise.init(sources);
    _recaptchaSiteKey = recaptchaSiteKey;
  },
  initSearch: function initSearch() {
    return multiSearch();
  }
};